import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  // memo: 2023/12/15 要望により一時的にシミュレーション画面でのShapeFileのインポートを有効化
  // https://aidiot-dev.slack.com/archives/C04FY9KDGBY/p1702634902413499
  async importShapeFile({ commit }, payload) {
    return await apiService.post(route('member.fcs.manage_import.import_shape_file'), payload)
  },
  async getManagementPlans({ commit }, payload) {
    const res = await apiService.post(route('member.fcs.dashboard.management_plans'), payload)
    if (res && res.data) {
      return res.data
    }
  },
  async getSelectedAreaManagementPlans({ commit }, payload) {
    const res = await apiService.post(route('member.fcs.dashboard.selected_area_management_plans'), payload)
    if (res.success && res.data) {
      return res.data
    }
  },
  async getTreeSpecies({ commit }, payload) {
    const res = await apiService.get(route('member.fcs.dashboard.tree_species'), payload)
    if (res.success && res.data) {
      return res.data
    }
  },
  async getCo2Absorption({ commit }, payload) {
    const res = await apiService.post(route('member.fcs.dashboard.get_co2_absorption'), payload)
    if (res && res.success && res.data) {
      return res
    } else if (res && !res.success && res.data.message) {
      return res
    }
  },
  async getSpatialFiles({ commit }, payload) {
    const res = await apiService.get(route('member.fcs.dashboard.spatial_files'), payload)
    if (res && res.data) {
      return res.data
    }
  },
  async getChartAndTableInfo({ commit }, payload) {
    const res = await apiService.get(route('member.fcs.dashboard.chart_table_info'), payload)
    if (res && res.success && res.data) {
      return res
    } else if (res && !res.success && res.data) {
      return res
    }
  },
  async changeIsCredited({ commit }, payload) {
    const res = await apiService.post(route('member.fcs.dashboard.change_is_credited'), payload)
    if (res.success && res.data) {
      return res.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
